import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CountryModel } from 'src/app/masters/country/country.model';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import * as CommonConstants from '../../utils/common.constants';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AddAdministrationComponent } from './add-administration/add-administration.component';
import { AdministrationService } from './administration.service';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';

@Component({
  selector: 'app-search-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']

})
export class AdministrationComponent implements OnInit {

  organisms: OrganismModel[];
  countries: CountryModel[];
  towns: any[];
  columnDefs: any[];
  startIndex;
  rowsPerPage;
  totalRecords;
  paginationSize = CommonConstants.PAGINATION_SIZE;
  administrationSearchForm: FormGroup;
  rowData: any[];
  addAdministration;
  toggleColumn = true;
  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  addressTypeList : any[];
  
  newAdministration: AddAdministrationComponent;
  priv_addAdmin: boolean;
  @ViewChild(AddAdministrationComponent, { static: true }) set Content(newAdministrationRef) {
    this.newAdministration = newAdministrationRef;
  }

  constructor(public router: Router, private masterService: MasterService, private administrationService: AdministrationService
    , private formBuilder: FormBuilder, private loaderService: LoaderService,private sharedService : SharedService) {

    this.columnDefs = [
      // { headerName: 'Id', field: 'adminId' },
      { headerName: 'Name', field: 'compaVaName'},
      { headerName: 'Organism', field: 'orgName' },
      { headerName: 'Work Phone', field: 'compaVaWorkPhone'},
      { headerName: 'Mobile Phone', field: 'compaVaMobilePhone1'},
      { headerName: 'Email', field: 'compaVaEmail' }
    ];

  }

  ngOnInit() {
    this.priv_addAdmin=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_ADMINISTRATOR);
    this.pSearch.pSearch["active"]=true;
    this.pSearch.partnerType=CommonConstants.PARTNER_ADMINISTRATION_TYPE;
    this.loadMasterData();
    this.getFormGroup();
    this.search();
  }

  /**
    * Declare form group
    *  
    */
  private getFormGroup() {
    this.administrationSearchForm = this.formBuilder.group({
      'orgsmId': new FormControl(),
      'compaVaName': new FormControl(),
      'cotryId': new FormControl(),
      'townId': new FormControl()

    })
  }

  loadMasterData() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.towns = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countries = response['result'];
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
  }
  addNewAdministration() {
    this.newAdministration.addAdministrationTitle = true;
    this.newAdministration.editAdministrationTitle = false;
    this.router.navigate(['addAdministration']);
  }
  hideRightDiv() {
    this.addAdministration = false;
    this.toggleColumn = true;
  }

  search() {
    this.startIndex = 0;
    this.hideRightDiv();
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    this.paginatedList();
    
    /* this.hospitalService.searchHospitals(this.hospitalSearch).subscribe(response => {
      console.log(response['result']);
      this.rowData = response['result'];
    }) */
  }

  paginatedList() {
    this.loaderService.display(true);
    this.pSearch.pSearch['partnerType'] = 6;
    this.pSearch.pSearch['active']=this.pSearch.pSearch['active'] ? 'A' :'I';
    this.administrationService.searchAdministrators(  this.pSearch.pSearch, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        result = result.map(item => ({
          ...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null
        }))
      }
      this.rowData = result;
      this.totalRecords = result.length;
    },
    error => {
      this.loaderService.display(false);
    })
  }

  paginate(event: any) {
    this.startIndex = event.first;
    this.rowsPerPage = event.rows;
    this.paginatedList();
  }

  onRowClicked(event: any) {
    this.addAdministration = true;
    this.toggleColumn = false;
    this.newAdministration.addAdministrationTitle = false;
    this.newAdministration.editAdministrationTitle = true;
    this.loadPharmacyById(event);
  }


  loadPharmacyById(event: any) {
    this.loaderService.display(true);
    this.administrationService.getAdministratorById(event.data.adminId).subscribe(response => {
      this.loaderService.display(false);
      this.newAdministration.hospDepartment.departmentList = [];
      this.newAdministration.hospAddress.addressList = [];
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newAdministration.administrationForm.patchValue({
          adminId: result["adminId"],
          compaNuNumberEmployees: result["compaNuNumberEmployees"],
          compaVaEmail: result["compaVaEmail"],
          compaVaMobilePhone1: result["compaVaMobilePhone1"],
          compaVaWorkPhone: result["compaVaWorkPhone"],
          compaVaMobilePhone2: result["compaVaMobilePhone2"],
          compaVaNameEn: result["compaVaNameEn"],
          compaVaWorkFax: result["compaVaWorkFax"],
          leforId: result["leforId"],
          orgsmId: result["orgsmId"],
          pacatId: result["pacatId"],
          pctypId: result["pctypId"],
          pagrpId: result["pagrpId"],
          natioId: result["natioId"],
          certiId: result["certiId"],
          paCatId: result["paCatId"],
          compaVaHomepage: result["compaVaHomepage"],
          staRecCode: result["staRecCode"] ==='A' ? true : false
        });

        result['addressList'] = result.addressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description: null,
          townName: item.townId ? this.towns.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countries.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        }));
        this.newAdministration.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['departmentList']));
        this.sharedService.setOrganismDepartment(this.newAdministration.hospDepartment.departmentList );
        this.newAdministration.hospAddress.addressList = JSON.parse(JSON.stringify(result['addressList']));
        this.newAdministration.hospContact.employeeList = JSON.parse(JSON.stringify(result['employeeList']));
        this.newAdministration.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  reset() {
    this.administrationSearchForm.reset();
    this.rowData =[];
    this.pSearch.pSearch={};
    this.hideRightDiv();
  }
}
